module.exports = __webpack_public_path__ + "static/media/scrubber.943aa68a.svg";